import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { opsQuery } from 'store/query';

import { DeliveryTracking } from './types';

export * from './types';

export const tagTypes = ['deliveryTracking'];

// Delivery tracking (owner, 25 Oct 2026): read from Ops for the event orders
// on screen (at most 100 ids). Empty when tracking is off for the company.
export const deliveryTrackingApi = createApi({
  tagTypes,
  baseQuery: opsQuery,
  reducerPath: 'deliveryTrackingApi',
  endpoints: (build) => ({
    list: build.query<DeliveryTracking[], number[]>({
      providesTags: tagTypes,
      query: (eventOrderIds) => ({
        method: 'get',
        // Never send the page to Not Found if Ops lacks the route (an older
        // Ops build during a deploy): the labels just stay hidden.
        headers: { 'allow-not-found': 'true' },
        url: `${URL.DELIVERY_TRACKING}?eventOrderIds=${eventOrderIds
          .slice(0, 100)
          .join(',')}`,
      }),
    }),
  }),
});

export const { useListQuery: useDeliveryTrackingListQuery } =
  deliveryTrackingApi;
